import { render } from "./CitiesIndex.vue?vue&type=template&id=09562fc5"
import script from "./CitiesIndex.vue?vue&type=script&lang=js"
export * from "./CitiesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__